<template>
  <div class="login">
    <!-- <img src="./../assets/images/login/LOGO.png" alt="" class="LOGO" /> -->
    <div class="sliderDialog">
      <el-dialog
        title=""
        :visible.sync="sliderDialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :custom-class="'sliderDialogS'"
        center
        :show-close="false"
        width="600px"
      >
        <div class="sliderDialogClose" @click="sliderDialog = false">✖</div>
        <slide-verify
          ref="slideblock"
          @success="onSuccess"
          @again="onAgain"
          @fulfilled="onFulfilled"
          @fail="onFail"
          @refresh="onRefresh"
          :slider-text="text"
          :accuracy="accuracy"
        ></slide-verify>
      </el-dialog>
      <el-dialog
        title="请选择要登录的角色"
        :visible.sync="chooseUserType"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        center
        width="400px"
      >
        <div class="dialogContent">
          <div
            v-for="item in rolesChooseArr"
            :key="item.userType"
            @click="chooseRoleLogin(item)"
          >
            {{ item.typeName }}
          </div>
        </div>
      </el-dialog>
    </div>
    <div class="login-content">
      <div class="login-box">
        <div class="loginTitle">慧学智通数字教学平台</div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="demo-ruleForm"
        >
          <el-form-item prop="username">
            <el-input
              v-model="ruleForm.username"
              class="input-width"
              placeholder="请输入手机号或邮箱"
              prefix-icon="el-icon-user"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="pwd">
            <el-input
              v-model="ruleForm.pwd"
              class="input-width"
              placeholder="请输入密码"
              prefix-icon="el-icon-lock"
              show-password
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="captcha" v-if="yanzhengma">
            <el-input
              v-model="ruleForm.captcha"
              class="input-width captcha"
              placeholder="请输入验证码"
              prefix-icon="el-icon-document-checked"
              clearable
            ></el-input>
            <span class="captcha-wrap">
              <img :src="imgCodeUrl" alt />
            </span>
          </el-form-item>
          <el-checkbox
            v-model="checked"
            @click="recoverPassword"
            class="password-set"
            >记住密码</el-checkbox
          >
          <el-form-item>
            <el-button
              type="primary"
              size="biggest"
              class="loginbtn"
              @click="submitForm('ruleForm')"
              >登 录</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="versionInfo">
      © 2019-南京易科姆智能科技有限公司|
      <span class="beian" @click="openNewWeb">苏ICP备19013888号</span
      >|苏公网安备32011502010935号
    </div>
  </div>
</template>
<script>
// import { mapActions, mapMutations } from 'vuex'
// import { USER_MUTATION_TYPES, USER_ACTION_TYPES } from '../store'
import slideVerify from './../../compoents/ecom-slide/slide-verify.vue'
import { orderService } from './../../api/index'
import common from './../../common/common'
export default {
  components: {
    slideVerify
  },
  data() {
    return {
      ruleForm: {
        username: '', // 17354166555
        pwd: '',
        captcha: '123'
      },
      rolesChooseArr: [],
      rules: {
        username: [
          { required: true, message: '请输入手机号或邮箱', trigger: 'blur' }
        ],
        pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      imgCodeUrl: '',
      checked: false,
      session: (Math.random() * 10000).toFixed(0),
      yanzhengma: false,
      chooseUserType: false,
      // 滑块验证
      sliderDialog: false,
      msg: '',
      text: '向右滑动->',
      accuracy: 5 // 精确度小，可允许的误差范围小；为1时，则表示滑块要与凹槽完全重叠，才能验证成功。默认值为5
    }
  },
  methods: {
    openNewWeb() {
      window.open('https://beian.miit.gov.cn')
    },
    chooseRoleLogin(item) {
      let sha512 = require('js-sha512').sha512
      const formData = new FormData()
      formData.append('username', this.ruleForm.username)
      formData.append('password', sha512(this.ruleForm.pwd))
      if (item.userType == 0) {
        this.login0(formData)
      } else if (item.userType == 1) {
        this.login01(formData)
      } else if (item.userType == 2) {
        this.login2(formData)
      } else {
        this.login3()
      }
    },
    // 获取状态管理 异步事件
    // ...mapActions([
    //   USER_ACTION_TYPES.LOGIN,
    //   USER_ACTION_TYPES.LOGOUT,
    //   USER_ACTION_TYPES.UTLOGIN
    // ]),
    // 获取状态管理 同步事件
    // ...mapMutations([USER_MUTATION_TYPES.SET_USER]),
    /**
     * 登陆操作
     * @return {Promise<void>}
     */
    async handleLogin() {
      // console.log(this.ruleForm)
      // 登录
      // let data = await userServices.login(this.ruleForm)
      // const { username, pwd } = this.ruleForm
      // let { data, code, message } = await this[USER_ACTION_TYPES.LOGIN]({
      //   username,
      //   pwd
      // })
      // if (code === 0) {
      //   this.$message.success('登录成功')
      //   // 跳转页面
      //   this.$router.replace('/')
      //   common.setCookie('device_username', this.ruleForm.username, 60 * 48)
      //   if (this.checked) {
      //     common.setCookie('device_pwd', this.ruleForm.pwd, 60 * 48)
      //   } else {
      //     common.setCookie('device_pwd', '')
      //     // this.$message.error(data.message)
      //   }
      // } else {
      //   this.sliderDialog = false
      //   this.handleClick()
      //   this.$message.error('请检查输入账号和密码是否正确')
      // }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.sliderDialog = true
          this.handleClick()
        } else {
          // console.log('error submit!!')
          return false
        }
      })
    },

    recoverPassword() {
      this.checked = !this.checked
    },
    // ------------滑块验证------------------------
    // 成功通过
    onSuccess(times) {
      this.sliderDialog = false
      this.login()
      // this.chooseUserType = true
      // this.handleLogin()
      // this.msg = `login success, 耗时${(times / 1000).toFixed(1)}s`
    },
    async login() {
      let sha512 = require('js-sha512').sha512
      const formData = new FormData()
      formData.append('username', this.ruleForm.username)
      formData.append('password', sha512(this.ruleForm.pwd))
      let data = await orderService.login(formData)
      if (data.code == 0) {
        common.setCookie('device_username', this.ruleForm.username, 60 * 48)
        if (this.checked) {
          common.setCookie('device_pwd', this.ruleForm.pwd, 60 * 48)
        } else {
          common.setCookie('device_pwd', '')
        }
        if (data.data.lastUserType || data.data.lastUserType === 0) {
          if (data.data.lastUserType == 0) {
            this.login0(formData)
          } else if (data.data.lastUserType == 1) {
            this.login01(formData)
          } else if (data.data.lastUserType == 2) {
            this.login2(formData)
          } else {
            this.login3()
          }
        } else {
          let arr = data.data.roles.map(el => {
            return {
              typeName:
                el.userType == 1
                  ? '机构管理员'
                  : el.userType == 0
                  ? '系统管理员'
                  : el.userType == 2
                  ? '学校管理员'
                  : '学科教师',
              show: el.userType < 4,
              formData: formData,
              ...el
            }
          })
          this.rolesChooseArr = arr.filter(el => el.show)
          this.chooseUserType = true
        }
      } else {
        this.$message.error(data.msg)
      }
    },
    // 全国用户中心登录
    async login01(formData) {
      let data = await orderService.login01(formData)
      if (data.code == 0) {
        localStorage.nationwideInfo = JSON.stringify(data.data)
        location.replace(`${window.origin}/ums/`)
      } else {
        this.$message.error(data.msg)
      }
    },
    async login0(formData) {
      let data = await orderService.login0(formData)
      if (data.code == 0) {
        localStorage.nationwideInfo = JSON.stringify(data.data)
        location.replace(`${window.origin}/ums/`)
      } else {
        this.$message.error(data.msg)
      }
    },
    // 校级用户中心登录
    async login2(formData) {
      let data = await orderService.login2(formData)
      if (data.code == 0) {
        localStorage.schoolManageInfo = JSON.stringify(data.data)
        location.replace(`${window.origin}/teaching/`)
      } else {
        this.$message.error(data.msg)
      }
    },
    // 备课端登录
    async login3() {
      let data = await orderService.login3({
        username: this.ruleForm.username,
        pwd: this.ruleForm.pwd
      })
      if (data.code == 0) {
        localStorage.zbbkInfo = JSON.stringify({
          truename: data.data.nickname,
          userName: data.data.teacherId,
          ...data.data
        })
        localStorage.token = data.data.token
        location.replace(`${window.origin}/zbbk/`)
      } else {
        this.$message.error(data.msg)
      }
    },
    // 验证失败
    onFail() {
      // console.log('验证不通过')
      this.msg = ''
    },
    // 点击右上角刷新图标
    onRefresh() {
      // console.log('点击了刷新小图标')
      this.msg = ''
    },
    // 刷新成功
    onFulfilled() {
      // console.log('刷新成功啦！')
    },
    // 检测出非人为操作
    onAgain() {
      // console.log('检测到非人为操作的哦！')
      this.msg = 'try again'
      // 刷新
      this.handleClick()
    },
    // 重置刷新
    handleClick() {
      this.$refs.slideblock.reset()
      this.msg = ''
    },
    async initPage(ut) {
      let { data, code, message } = await this[USER_ACTION_TYPES.UTLOGIN]({
        ut
      })
      if (code === 0) {
        this.$message.success('登录成功')
        // 跳转页面
        this.$router.replace('/')
      } else {
        this.$message.error('登录信息已过期！')
      }
    }
  },
  created() {
    var _self = this
    document.onkeydown = function(e) {
      var key = window.event.keyCode
      if (key === 13) {
        // _self.handleLogin()
      }
    }

    const pwd = common.getCookie('device_pwd')
    _self.ruleForm.username = common.getCookie('device_username')
    if (pwd) {
      _self.checked = true
      _self.ruleForm.pwd = pwd
    } else {
      _self.checked = false
      _self.ruleForm.pwd = ''
    }
  },
  watch: {},
  mounted() {},
  beforeDestroy() {
    document.onkeydown = function(e) {
      var key = window.event.keyCode
      if (key === 13) {
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sliderDialog {
  /deep/.el-dialog__close {
    font-size: 30px;
  }
}
.login {
  width: 100%;
  height: 100%;
  position: relative;
  left: 0;
  top: 0;
  background: url('./../../assets/image/bg@2x.png') no-repeat;
  // background: url('./../assets/images/login/bg.png') no-repeat;
  background-size: 100% 100%;
  position: relative;
  .LOGO {
    position: absolute;
    left: 0;
    top: 0;
  }
  .login-content {
    width: 600px;
    height: 520px;
    .box-top {
      width: 323px;
      height: 139px;
      img {
        width: 100%;
      }
      .verson-wrap {
        display: inline-block;
        width: 60px;
        height: 60px;
        position: absolute;
        bottom: 0px;
        img {
          width: 100%;
        }
        span {
          position: absolute;
          bottom: 25px;
          right: 10px;
          color: rgba(255, 255, 255, 0.5);
        }
      }
    }
    .login-box {
      width: 503px;
      height: 524px;
      position: absolute;
      top: 168px;
      right: 180px;
      border-radius: 10px;
      background: url('./../../assets/image/juxing.png') no-repeat;
      // background: url('./../assets/images/login/矩形.png');
      // background: white;
      // border: 1px solid green;
      background-size: cover;
      text-align: center;
      .loginTitle {
        text-align: center;
        margin-top: 29px;
        height: 28px;
        font-size: 28px;
        font-family: MFZhiHei_Noncommercial-Regular, MFZhiHei_Noncommercial;
        font-weight: 400;
        color: #ffffff;
        line-height: 28px;
        margin-bottom: 100px;
      }
      .password-set {
        // float: left;
        width: 100%;
        text-align: left;
        margin-bottom: 10px;
      }
      .title-span {
        margin: 0 10px;
      }
      .demo-ruleForm {
        width: 80%;
        margin: 80px auto 50px auto;
        height: calc(100% - 100px);
        // margin-left: 13%;
      }
      .loginbtn {
        width: 407px;
        height: 57px;
        background: #6aabff;
        margin-top: 35px;
        font-size: 25px;
        border-radius: 43px;
        border: 0;
      }
      .captcha {
        float: left;
        width: 60% !important;
      }
      .captcha-wrap {
        // float: right;
        display: inline-block;
        margin-left: 20px;
        width: calc(40% - 22px);
        height: 38px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
          vertical-align: top;
        }
      }
    }
  }
  .el-form-item {
    margin-bottom: 50px;
  }
}
</style>

<style lang="scss">
.sliderDialogS {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    width: auto;
    position: relative;
    .sliderDialogClose {
      width: 35px;
      height: 35px;
      color: white;
      position: absolute;
      right: -36px;
      top: -36px;
      z-index: 9999;
      text-align: center;
      line-height: 35px;
      font-size: 35px;
      cursor: pointer;
    }
  }
}
.login {
  .sliderDialog {
    .el-dialog {
      .dialogContent {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        div {
          width: 200px;
          height: 50px;
          background: #409eff;
          border-radius: 10px;
          line-height: 50px;
          font-size: 24px;
          color: #fff;
          text-align: center;
          margin: 10px 0;
          cursor: pointer;
        }
      }
      //   display: flex;
      //   flex-direction: column;
      //   margin: 0 !important;
      //   position: absolute;
      //   top: 50%;
      //   left: 50%;
      //   width: auto;
      //   transform: translate(-50%, -50%);
      //   /*height:600px;*/
      //   max-height: calc(100% - 30px);
      //   max-width: calc(100% - 30px);
      //   border-radius: 0;
      //   .el-dialog__body {
      //     padding: 0;
      //     position: relative;
      //     .sliderDialogClose {
      //       width: 35px;
      //       height: 35px;
      //       color: white;
      //       position: absolute;
      //       right: -36px;
      //       top: -36px;
      //       z-index: 9999;
      //       text-align: center;
      //       line-height: 35px;
      //       font-size: 35px;
      //       cursor: pointer;
      //     }
      //   }
      //   .el-dialog__header {
      //     display: none;
      //   }
      //   .el-dialog__footer {
      //     display: none;
      //   }
    }
  }
  .el-input__inner {
    padding-left: 40px;
    border: 0;
    border-bottom: 2px solid #e5e5e5;
    border-radius: 0;
    // font-size: px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #64a4f6;
    line-height: 25px;
  }
  .el-icon-lock:before {
    width: 30px;
    height: 30px;
    content: '';
    background: url('./../../assets/image/safety certificate.png') no-repeat;
    background-size: 100%;
  }
  .el-icon-user:before {
    content: '';
    width: 30px;
    height: 30px;
    background: url('./../../assets/image/user.png') no-repeat;
    background-size: 100%;
  }
  .el-icon-view:before {
    content: '';
    width: 30px;
    height: 15px;
    background: url('./../../assets/image/view.png') no-repeat;
    background-size: 100%;
  }
  .el-input__clear {
    width: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .el-icon-user {
    width: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .el-icon-lock {
    width: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .el-icon-circle-close {
    position: absolute;
    right: 30px;
    display: none;
  }
  .versionInfo {
    width: 100%;
    height: 50px;
    background: #3b3b3b;
    color: #969696;
    position: absolute;
    bottom: 0;
    left: 0;
    text-align: center;
    line-height: 50px;
    font-size: 14px;
    .beian {
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
